export default __webpack_public_path__ + "static/media/Metropolis-SemiBoldItalic.c9fc7e1f.otf";